/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

import React, { useEffect, useState } from 'react';
import { TextInput } from '@carbon/react';
import { useTranslation } from 'react-i18next';

function TestToolNegotiateAuth({ negotiateCreds, onChange }) {
  const [negotiateGssapiData, setNegotiateGssapiData] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    setNegotiateGssapiData(negotiateCreds.negotiateGssapiData ?? '');
  }, [negotiateCreds.negotiateGssapiData]);

  const handleHttpNegotiateGssapiDataChange = (event) => {
    const negotiateGssapiData = event.target.value;
    setNegotiateGssapiData(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ negotiateGssapiData });
    }
  };

  return (
    <div className="testToolNegotiateAuth">
      <div className="negotiateGssapiData">
        <div className="labelText">{t('gssapi_data')}</div>
        <TextInput id="negotiategssapidata" hideLabel labelText={t('gssapi_data')} value={negotiateGssapiData} onChange={handleHttpNegotiateGssapiDataChange} />
      </div>
    </div>
  );
}

export default TestToolNegotiateAuth;
